import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AnalyticsRouteTracker from "./components/AnalyticsRouteTracker";
import CampaignTracker from "./components/CampaignTracker";
import Cookies from "./components/Cookies";
import MetaRouteTracker from "./components/MetaRouteTracker";
import OnboardingWizard from "./components/onboarding/OnboardingWizard";
import DownloadPage from "./pages/DownloadPage";
import LandingPage from "./pages/landing/LandingPage";

const App: React.FC = () => {
  return (
    <>
      <AnalyticsRouteTracker />
      <CampaignTracker />
      <MetaRouteTracker />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/onboarding" element={<OnboardingWizard />} />
        <Route path="/login" element={<Navigate to="/download?existing=1" replace />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Cookies />
    </>
  );
};

export default App;
